import { emitterProps, globalEmitter } from 'helpers/emitter-event'
import { addCartItem, updateCart } from 'libs/cart'

window.addToCart = async (variant, preOrderETA, quantity) => {
  console.log('Adding to cart:', variant)

  preOrderETA = preOrderETA || null
  quantity = quantity || 1

  let preOrderProperties = { }

  if (variant.available && variant.inventory_quantity <= 0 && variant.inventory_policy === 'continue' && preOrderETA) {
    preOrderProperties = {
      'Pre-order': preOrderETA
    }
  }

  const id = parseInt(variant.id)
  const cartSingle = await addCartItem(id, preOrderProperties, quantity)

  if (!cartSingle) throw new Error('Can not add to cart')

  const newCart = await updateCart()

  globalEmitter.emit(emitterProps.cart.add, newCart)
}
